import React from "react";
/* import { Cluster, UIComponent, Html, mapClusterKey, Page } from '../Base'; */
import { runtime } from "@codeArt/common";
import { Message } from "../modal/index";
import _ from "lodash";
import { empty } from "@codeArt/utils/common";
import { diff, indexOf } from "@codeArt/utils/array";

function globalId() {
  return _.uniqueId("dataGrid-");
}

export default class DataBase extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      selected: []
    };
    this.radioName = "data-radio-" + globalId();
  }

  _getRowDisabled(row){
    return this.props.getRowDisabled ? this.props.getRowDisabled(row) : false;
  }

  getGroupParams() {
    if (!this.group) return;
    let item = this.group.current();
    if (item) {
      let t = {};
      t[item.field] = item.value;
      return t;
    }

    return {};
  }

  getParams() {
    let { getParams, processParams } = this.props;
    let arg = getParams ? getParams() : {};
    arg = { ...arg, ...this.getGroupParams() };
    if (processParams) {
      arg = processParams(arg);
    }
    return arg;
  }

  selectMode(mode) {
    //none,checkbox,radio
    this.setState({
      selectMode: mode
    });
  }

  handleRowClick = (event, key, row) => {
    let { onRowSelect, onRowSelected, rowSelect,getRowDisabled } = this.props;

    if(this._getRowDisabled(row)) return;

    let canSelected = true;
    if (onRowSelect) canSelected = onRowSelect(row, event);

    if (canSelected === false) return;
    let checkbox = this.checkbox();
    let radio = this.radio();
    if (!checkbox && !radio) return;

    if (rowSelect) {
      const { selected } = this.state;
      let newSelected = this.addOrRemove(selected, key);
      this.setState({ selected: newSelected }, () => {
        if (onRowSelected) onRowSelected(row, newSelected);
        this.selectChanged();
      });
    } else {
      if (onRowSelected) onRowSelected(row);
    }
  };

  selectChanged() {
    this.tipSelect();
    let { selectChanged } = this.props;
    if (selectChanged) selectChanged(this.state.selected);
  }

  tipSelect() {
    if (runtime.pc) return; //pc不提示
    let length = this.state.selected.length;
    Message.snackbar(length === 0 ? "选项已清空" : `已选 ${length} 项`);
  }

  checkbox() {
    let { selectMode } = this.state;
    if (empty(selectMode)) return this.props.checkbox;
    return selectMode === "checkbox";
  }

  radio() {
    let { selectMode } = this.state;
    if (empty(selectMode)) return this.props.radio;
    return selectMode === "radio";
  }

  get() {
    return this.state.selected;
  }
  
  set(v) {
    this.setState({ selected: v });
  }

  getSelectItems(){
    let items = this.get();
    let my=this;
    return _.filter(this.getData().rows,(row)=>{
      let value = my.getRowKey(row).value;
      return _.findIndex(items,(t)=> t.value == value) > -1;
    });
  }

  reverseSet(items) {
    let rows = this.getData().rows;
    items = items.map(t => this.getRowKey(t));
    rows = rows.map(t => this.getRowKey(t));

    let reverseItems = diff(rows, items, (v0, v1) => v0.value === v1.value);
    this.set(reverseItems);
  }

  reverseGet() {
    let rows = this.getData().rows;
    let items = this.get();
    items = items.map(t => this.getRowKey(t));
    rows = rows.map(t => this.getRowKey(t));

    return diff(rows, items, (v0, v1) => v0.value == v1.value);
  }

  reset() {
    this.setState({ selected: [] });
  }
  getValues() {
    return this.state.selected.map(s => s.value);
  }
  isSelected = key => indexOf(this.state.selected, s => s.value === key.value) !== -1;

  handleTargetClick = (event, key, row) => {
    const { selected } = this.state;
    let { onBoxSelected,getRowDisabled } = this.props;

    if(this._getRowDisabled(row)) return;

    let newSelected = this.addOrRemove(selected, key);
    this.setState({ selected: newSelected }, () => {
      if (onBoxSelected) onBoxSelected(row, newSelected);
      this.selectChanged();
    });
    event.stopPropagation();
  };

  addOrRemove(selected, key) {
    const selectedIndex = indexOf(selected, s => s.value == key.value);
    let newSelected = [];

    if (this.radio()) {
      if (selectedIndex === -1) newSelected.push(key);
    } else if (this.checkbox()) {
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, key);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1)
        );
      }
    }

    return newSelected;
  }

  getRowKey(row) {
    //获得行的关键信息，这包括:value、text
    let { keyColumn, group } = this.props;
    if (keyColumn) {
      let data = {};
      for (let key in keyColumn) {
        /*  data[key] = row[keyColumn[key]]; */
        for (let rowKey in row) {
          if (rowKey.toLowerCase() === keyColumn[key].toLowerCase()) {
            data[key] = row[rowKey];
            break;
          }
        }
      }
      if (group) data.group = group;
      return data;
    } else {
      let data = {
        value: row["Id"] || row["id"],
        text: row["Name"] || row["name"]
      };
      if (group) data.group = group;
      return data;
    }
  }

  updateArray(array, item) {
    //用item替换array中对应的项
    if (!array || array.length == 0) return;

    let getKey = t => {
      return t.value || this.getRowKey(t).value;
    }; //t有可能就是选项本身，这时候value就是key
    let itemKey = getKey(item);
    for (let i = 0; i < array.length; i++) {
      if (getKey(array[i]) == itemKey) {
        array[i] = item;
        return;
      }
    }
  }

  deleteArray(array, item) {
    //在array中删除对应的item
    if (!array || array.length == 0) return;
    let getKey = t => {
      return t.value || this.getRowKey(t).value;
    }; //t有可能就是选项本身，这时候value就是key

    let itemKey = getKey(item);
    _.remove(array, t => {
      return getKey(t) == itemKey;
    });
  }

  isUnmounted() {
    return this._unmounted;
  }

  componentWillUnmount() {
    this._unmounted = true;
  }

  componentWillMount() { }

  componentDidMount() {
    let { lazy, onInit } = this.props;
    if (onInit) {
      onInit(this);
    }

    //自动加载
    if (!lazy) {
      this.load();
    }
  }
}
